var _path, _path2, _g, _path3, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#C9E9F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10547_31103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8452 45.0004 11.8453 46.8535 12.9152L72.7845 27.8864C74.6377 28.9564 75.7793 30.9337 75.7793 33.0735V63.0161C75.7793 65.1559 74.6377 67.1332 72.7845 68.2032L46.8535 83.1744C45.0004 84.2444 42.7172 84.2444 40.864 83.1744L14.933 68.2032C13.0798 67.1332 11.9382 65.1559 11.9382 63.0161V33.0735C11.9382 30.9337 13.0798 28.9564 14.933 27.8864L40.864 12.9152Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10547_31103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8639 12.9152C42.717 11.8452 45.0002 11.8453 46.8534 12.9152L72.7844 27.8864C74.6376 28.9564 75.7792 30.9337 75.7792 33.0735V63.0161C75.7792 65.1559 74.6376 67.1332 72.7844 68.2032L46.8534 83.1744C45.0002 84.2444 42.717 84.2444 40.8639 83.1744L14.9329 68.2032C13.0797 67.1332 11.9381 65.1559 11.9381 63.0161V33.0735C11.9381 30.9337 13.0797 28.9564 14.9329 27.8864L40.8639 12.9152Z",
    fill: "#86D1F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.0601C72.2298 83.5012 12.5546 43.3756 6.58582 9.86812L-27.8162 57.6639L55.5728 117.685L107.846 45.0601Z",
    fill: "#37B1E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10547_31103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 82,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2998 8.42178C3.2998 5.11386 5.98141 2.43225 9.28934 2.43225H78.3993C81.7072 2.43225 84.3888 5.11386 84.3888 8.42178V49.9237C84.3888 52.2917 82.4692 54.2114 80.1012 54.2114C77.7332 54.2114 75.8136 56.131 75.8136 58.499V63.0137C75.8136 65.1549 74.6706 67.1331 72.8157 68.2026L46.838 83.1801C44.9853 84.2483 42.7037 84.2476 40.8517 83.1784L14.9121 68.2032C13.0588 67.1333 11.9171 65.1559 11.9171 63.016V58.52C11.9171 56.1404 9.98809 54.2114 7.60848 54.2114C5.22886 54.2114 3.2998 52.2823 3.2998 49.9027V8.42178Z",
    fill: "#FCCE2C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10547_31103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3578 39.4734C42.8154 39.2092 43.3662 39.1756 43.847 39.3738L44.0482 39.4734L50.9779 43.4744C51.501 43.7764 51.8236 44.3343 51.8236 44.9382V52.9402C51.8235 53.4686 51.5766 53.9617 51.1644 54.2791L50.9779 54.4041L44.0482 58.405C43.5905 58.6692 43.0399 58.702 42.559 58.5037L42.3578 58.405L35.4281 54.4041C34.9051 54.1021 34.5825 53.544 34.5824 52.9402V44.9382C34.5824 44.4097 34.8294 43.9158 35.2416 43.5984L35.4281 43.4744L42.3578 39.4734Z",
    fill: "#2AC682",
    stroke: "#048760",
    strokeWidth: 1.78927
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0729 22.0436C53.5305 21.7794 54.0812 21.7458 54.5621 21.944L54.7633 22.0436L61.693 26.0446C62.216 26.3465 62.5387 26.9045 62.5387 27.5084V35.5104C62.5386 36.0388 62.2916 36.5319 61.8795 36.8492L61.693 36.9742L54.7633 40.9752C54.3056 41.2394 53.755 41.2722 53.274 41.0739L53.0729 40.9752L46.1432 36.9742C45.6202 36.6723 45.2976 36.1142 45.2975 35.5104V27.5084C45.2975 26.9799 45.5445 26.486 45.9567 26.1686L46.1432 26.0446L53.0729 22.0436Z",
    fill: "#2AC682",
    stroke: "#048760",
    strokeWidth: 1.78927
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3324 3.24695C43.1322 2.78515 44.1177 2.78515 44.9175 3.24695L51.8474 7.2479C52.6472 7.70969 53.14 8.56313 53.14 9.48673V17.4886C53.14 18.4122 52.6472 19.2657 51.8474 19.7275L44.9175 23.7284C44.1177 24.1902 43.1322 24.1902 42.3324 23.7284L35.4025 19.7275C34.6027 19.2657 34.1099 18.4122 34.1099 17.4886V9.48673C34.1099 8.56313 34.6027 7.70969 35.4025 7.2479L42.3324 3.24695Z",
    fill: "#E7F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2814 22.6918C74.739 22.4276 75.2897 22.3941 75.7706 22.5922L75.9718 22.6918L82.9015 26.6928C83.4245 26.9948 83.7472 27.5527 83.7472 28.1567V36.1586C83.7471 36.6871 83.5001 37.1802 83.088 37.4975L82.9015 37.6225L75.9718 41.6235C75.5141 41.8876 74.9634 41.9204 74.4825 41.7221L74.2814 41.6235L67.3517 37.6225C66.8287 37.3206 66.5061 36.7625 66.506 36.1586V28.1567C66.506 27.6281 66.753 27.1342 67.1652 26.8168L67.3517 26.6928L74.2814 22.6918Z",
    fill: "#2AC682",
    stroke: "#048760",
    strokeWidth: 1.78927
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4914 21.5405C32.2912 21.0787 33.2767 21.0787 34.0765 21.5405L41.0064 25.5414C41.8062 26.0032 42.299 26.8566 42.299 27.7802V35.7821C42.299 36.7057 41.8062 37.5592 41.0064 38.021L34.0765 42.0219C33.2767 42.4837 32.2912 42.4837 31.4914 42.0219L24.5615 38.021C23.7616 37.5592 23.2689 36.7057 23.2689 35.7821V27.7802C23.2689 26.8566 23.7616 26.0032 24.5615 25.5414L31.4914 21.5405Z",
    fill: "#E7F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7835 4.02216C64.2412 3.75793 64.7919 3.7244 65.2728 3.92255L65.4739 4.02216L72.4036 8.02313C72.9267 8.32512 73.2493 8.88303 73.2493 9.487V17.489C73.2492 18.0174 73.0023 18.5105 72.5901 18.8278L72.4036 18.9528L65.4739 22.9538C65.0162 23.218 64.4656 23.2507 63.9847 23.0524L63.7835 22.9538L56.8538 18.9528C56.3309 18.6509 56.0082 18.0928 56.0081 17.489V9.487C56.0081 8.95845 56.2551 8.46454 56.6673 8.14716L56.8538 8.02313L63.7835 4.02216Z",
    fill: "#2AC682",
    stroke: "#048760",
    strokeWidth: 1.78927
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1599 39.6368C63.9598 39.175 64.9453 39.175 65.7451 39.6368L72.675 43.6377C73.4748 44.0995 73.9675 44.953 73.9675 45.8766V53.8785C73.9675 54.802 73.4748 55.6555 72.675 56.1173L65.7451 60.1182C64.9453 60.58 63.9598 60.58 63.1599 60.1182L56.2301 56.1173C55.4302 55.6555 54.9375 54.8021 54.9375 53.8785V45.8766C54.9375 44.953 55.4302 44.0995 56.2301 43.6377L63.1599 39.6368Z",
    fill: "#E7F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4914 57.7329C32.2912 57.2711 33.2767 57.2711 34.0765 57.7329L41.0064 61.7339C41.8062 62.1957 42.299 63.0491 42.299 63.9727V71.9746C42.299 72.8982 41.8062 73.7516 41.0064 74.2134L34.0765 78.2144C33.2767 78.6762 32.2912 78.6762 31.4914 78.2144L24.5615 74.2134C23.7616 73.7516 23.2689 72.8982 23.2689 71.9746V63.9727C23.2689 63.0491 23.7616 62.1957 24.5615 61.7339L31.4914 57.7329Z",
    fill: "#E7F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7199 39.6368C21.5197 39.175 22.5052 39.175 23.305 39.6368L30.2349 43.6377C31.0347 44.0995 31.5275 44.953 31.5275 45.8766V53.8785C31.5275 54.802 31.0347 55.6555 30.2349 56.1173L23.305 60.1182C22.5052 60.58 21.5197 60.58 20.7199 60.1182L13.79 56.1173C12.9902 55.6555 12.4974 54.8021 12.4974 53.8785V45.8766C12.4974 44.953 12.9902 44.0995 13.79 43.6377L20.7199 39.6368Z",
    fill: "#E7F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.288 57.7329C53.0878 57.2711 54.0733 57.2711 54.8732 57.7329L61.803 61.7339C62.6029 62.1957 63.0956 63.0491 63.0956 63.9727V71.9746C63.0956 72.8982 62.6029 73.7516 61.803 74.2134L54.8732 78.2144C54.0733 78.6762 53.0878 78.6762 52.288 78.2144L45.3581 74.2134C44.5583 73.7516 44.0655 72.8982 44.0655 71.9746V63.9727C44.0655 63.0491 44.5583 62.1957 45.3581 61.7339L52.288 57.7329Z",
    fill: "#E7F4FA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10547_31103)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 27.5,
    width: 16,
    height: 39,
    rx: 3.5,
    fill: "white",
    stroke: "#C9E9F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 35L78.5 31L72 35",
    stroke: "#006692",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 41L78.5 37L72 41",
    stroke: "#006692",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 47L78.5 43L72 47",
    stroke: "#006692",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 53L78.5 49L72 53",
    stroke: "#006692",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 59L78.5 55L72 59",
    stroke: "#006692",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 65L78.5 61L72 65",
    stroke: "#006692",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 28,
    width: 15,
    height: 38,
    rx: 3,
    stroke: "#C9E9F8",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10547_31103"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 27,
    width: 17,
    height: 40,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.4c06576d8e71a81ed3fdaa7e218288d5.svg";
export { ForwardRef as ReactComponent };